module.exports = __webpack_public_path__ + "static/media/ultra_cosmicblack.13f6dadc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/ultra/ultra_cosmicblack.png
// module id = 2151
// module chunks = 0